import {animate, inView, stagger, timeline} from 'motion';

export function wbsAnimations() {

    const selectElementsToAnimate = document.querySelectorAll('.wbs-animation');

    if (selectElementsToAnimate.length > 0) {


        selectElementsToAnimate.forEach(element => {
            const animationId = element.dataset.wbsAnim;

            if (!animationId || !animations[animationId]) {
                return;
            }


            const options = element.dataset.options ? JSON.parse(element.dataset.options) : {
                delay: 0.2,
                duration: 0.9,
                easing: [0.17, 0.55, 0.55, 1]
            };

            inView(element, ({target}) => {
                animate(
                    target,
                    animations[animationId],
                    options
                );
            })


        });
    }
}

export function wbsSequence() {
    const selectElementsToAnimate = document.querySelectorAll('.wbs-sequence');
    selectElementsToAnimate.forEach(element => {
        const animationSequence = element.dataset.wbsSequence;

        if (!animationSequence || !sequence[animationSequence]) {
            return;
        }

        inView(element, ({target}) => {
            timeline(sequence[animationSequence], {
                defaultOptions: {ease: "ease-in-out"},

            })
        })


    });

}

const animations = {
    slideUp: {
        opacity: 1, transform: "translateY(0)",
    }
}

const sequence = {
    banner: [
        ['.hero-banner__logo', {opacity: 1, transform: "translateY(0)"}, {duration: 2}],
        ['.hero-banner__header', {opacity: 1, transform: "translateY(0)"}, {duration: 2, at: "<" }],
        ['.hero-banner__text', {opacity: 1, transform: "translateY(0)"}, {duration: 2, at: "-2" }],
    ]
}







